import { render, staticRenderFns } from "./UpdateShippingAddress.vue?vue&type=template&id=b1957eb0"
import script from "./UpdateShippingAddress.vue?vue&type=script&lang=js"
export * from "./UpdateShippingAddress.vue?vue&type=script&lang=js"
import style0 from "./UpdateShippingAddress.vue?vue&type=style&index=0&id=b1957eb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports